import type { Feature } from '@tectonics/prs/feature';
import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import type {
  CountrySchema,
  DisplayFeature,
  FieldFeature,
} from './types';

type RuntimeFeature =
  | DisplayFeature
  | FieldFeature;

const toRuntimeFeature = (
  feature: RuntimeFeature,
): Feature => ({
  name: feature.type === 'field'
    ? feature.id
    : `${feature.type}_${feature.id}`,
  traits: feature.traits ?? [],
});

const isFeatureEnabled = (
  feature: RuntimeFeature,
  incomingPayment: IncomingPayment,
): boolean => (
  feature.statuses.includes(incomingPayment.status)
  && (feature.condition?.({ incomingPayment }) ?? true)
);

export const buildFeatureList = (
  features: readonly RuntimeFeature[],
  incomingPayment: IncomingPayment,
): Feature[] => (
  features
    .filter(feature => isFeatureEnabled(feature, incomingPayment))
    .map(toRuntimeFeature)
);

export const buildPaymentMethodGenerators = (
  paymentMethods: CountrySchema['paymentMethods'],
) => Object.fromEntries(
  Object.entries(paymentMethods).map(([paymentMethod, { display }]) => [
    paymentMethod,
    ({ incomingPayment }: { readonly incomingPayment: IncomingPayment }) => (
      buildFeatureList(display, incomingPayment)
    ),
  ]),
);
